import React from 'react';
import PropTypes from 'prop-types';

import { AlertDialog, toast, EndlessScroll, NoData } from '@meronex/components';

import MemberItem from './MemberItem';
import { membersMng } from '../api/membersMng';
import AddMemberDialog from './AddMemberDialog';
import EditMemberDialog from './EditMemberDialog';

function MembersList(props) {
  const { filters, openAddDialog, onAddDialogClose } = props;

  const [deleting, setDeleting] = React.useState();
  const [openDeleteAlert, setOpenDeleteAlert] = React.useState(false);
  const [openAddMemberDialog, setOpenAddMemberDialog] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState();
  const [selectedItemIndex, setSelectedItemIndex] = React.useState();
  const [openEditMember, setOpenEditMember] = React.useState();

  const listRef = React.useRef(null);

  // Support opening add dialog from parent
  React.useEffect(() => {
    if (openAddDialog) {
      setOpenAddMemberDialog(true);
    }
  }, [openAddDialog]);

  React.useEffect(() => {
    listRef.current.refreshList();
  }, [filters]);

  const onConfirmDelete = async () => {
    setDeleting(true);
    setOpenDeleteAlert(false);
    try {
      await membersMng.deleteMember(selectedItem);
      toast.success('Member successfully deleted');
      setDeleting(false);
      listRef.current.refreshList();
    } catch (e) {
      toast.error(e.reason);
      setDeleting(false);
    }
  };

  const loadMembers = async ({ limit = 9, skip = 0 }) => {
    return await membersMng.getMembersCursor({ skip, limit, filters });
  };

  const _onAdd = async () => {
    listRef.current.refreshList();
  };

  const _onEdit = async () => {
    listRef.current.refreshItems();
  };

  const renderMember = (member, isScrolling, index) => {
    return (
      <MemberItem
        member={member}
        onEditClick={() => {
          setSelectedItem(member);
          setSelectedItemIndex(index);
          setOpenEditMember(true);
        }}
        onDeleteClick={() => {
          setOpenDeleteAlert(true);
          setSelectedItem(member);
        }}
        onClick={() => {
          setSelectedItem(member);
          setSelectedItemIndex(index);
        }}
      />
    );
  };

  return (
    <>
      <EndlessScroll
        ref={listRef}
        getListItems={loadMembers}
        remoteRowCount={999999}
        noRowRenderer={() => {
          return (
            <NoData
              message={'Add new members'}
              onClick={() => {
                setOpenAddMemberDialog(true);
              }}
            />
          );
        }}
        selectedItemIndex={selectedItemIndex}
        renderItem={renderMember}
      />
      <AlertDialog
        open={openDeleteAlert}
        loading={deleting}
        onClose={() => {
          setOpenDeleteAlert(false);
        }}
        onConfirm={onConfirmDelete}
      />
      {(openAddMemberDialog || openAddDialog) && (
        <AddMemberDialog
          open={openAddMemberDialog || openAddDialog}
          onAdd={_onAdd}
          onClose={() => {
            setOpenAddMemberDialog(false);
            if (onAddDialogClose) onAddDialogClose();
          }}
        />
      )}
      {openEditMember && (
        <EditMemberDialog
          open={openEditMember}
          member={selectedItem}
          onEdit={_onEdit}
          onClose={() => {
            setOpenEditMember(false);
            setSelectedItem(false);
            setSelectedItemIndex(undefined);
          }}
        />
      )}
    </>
  );
}
MembersList.propTypes = {
  filters: PropTypes.object,
  openAddDialog: PropTypes.bool,
  onAddDialogClose: PropTypes.func,
};

MembersList.defaultProps = {};
export default MembersList;
